import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./store.js";
import { router } from "./router.js";
import 'office-ui-fabric-react/dist/css/fabric.css';
import './stylesheets/main.css';
import './stylesheets/style.css';

// render the main component
ReactDOM.render(
  <Provider store={store}>
    {router}
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./client/index.js